export default __webpack_public_path__ + "static/media/HOLD_302159992_AR_-1_SPBBGGYHUIDW.879d3ba5.png";